import PaymentService from "../../../api/paymentService";

export type CpaySession = {
    paymentUrl: string;
    fields: Record<string, string>;
};

export const startCpayPayment = async (orderId: string, wishId: string, ticketCount: number, gift: object) => {
    const {data}: { data: CpaySession } = await PaymentService.startSession({
        order_id: orderId,
        ticket_count: ticketCount,
        wish_id: wishId,
        ...gift
    })

    // Auto-post (hidden form)
    const form = document.createElement("form");
    form.method = "POST";
    form.action = data.paymentUrl; // e.g., https://vpos.cpay.com.mk/mk-MK  :contentReference[oaicite:31]{index=31}
    Object.entries(data.fields).forEach(([k, v]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = k;
        input.value = v;
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
}
